<a class="brand-link" routerLink="/dashboard">
  <!-- Collapsed state: Always show BUSPRO icon -->
  @if (isCollapsed) {
    <img
      alt="BusPro"
      class="brand-icon"
      [src]="logoVariant === 'white' ? 'logo-white.png' : 'icons/icon-72x72.png'"
      onerror="this.style.display='none'"
    />
  }


  @if (!isCollapsed) {
      <img
        alt="BusPro"
        class="buspro-logo"
        [src]="logoVariant === 'white' ? 'logo-white.png' : 'logo-no-border-trimmed.png'"
        onerror="this.style.display='none'"
      />
  }
</a>
